unit FunctionType;
{

/* Initial. */

}

interface

uses
  JS,
  TypeType;

type
  TFunctionType = class
  private
    fFunctionKey: String;
    fName: String;
    fDescription: String;
    fType: TTypeType;
    fAdmin: Boolean;
    fActive: Boolean;
  public
    property FunctionKey: String read fFunctionKey;
    property Name: String read fName;
    property Description: String read fDescription;
    property FunctionType: TTypeType read fType;
    property Admin: Boolean read fAdmin;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TFunctionType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fFunctionKey := String(JSObject_Type['functionKey']);
    fName := String(JSObject_Type['name']);
    fDescription := String(JSObject_Type['description']);
    fType := TTypeType.Create(TJSJSON.stringify(JSObject_Type['type']));
    fAdmin := (String(JSObject_Type['admin']) = 'true');
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
